import globals from "web/script/modules/globals";

const FILTER_SCORE_THRESHOLD = 30;

export function getRequestScore(): number | null {
    const score = parseInt(globals.window.Lyst?.environment?.cfbs ?? "", 10);
    return Number.isNaN(score) ? null : score;
}

/**
 * Whether the current page request should be filtered out. An unknown score (e.g. in local dev)
 * is never filtered.
 */
export function shouldFilterRequest(): boolean {
    if (globals.window.Lyst?.environment?.cfvb === "true") {
        return true;
    }

    const score = getRequestScore();
    return score !== null && score < FILTER_SCORE_THRESHOLD;
}
